// extracted by mini-css-extract-plugin
export default {"container":"TeamManagement_container__Fx6jk","header":"TeamManagement_header__vcuUO"};